import { connect } from 'react-redux';
import View from './ConfirmationModalView';
import { isOpenSelector } from './ConfirmationModalSelector';
import { confirmationModalClose } from './ConfirmationModalActions';

const mapStateToProps = (state, ownProps) => ({
  isOpenState: isOpenSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  onCloseState: () => {
    dispatch(confirmationModalClose());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
